<template>
    <div v-if="activeView === 'form'" id="form-content" class="row">
        <div class="col-12 pt-2">
            <p
                class="lead fw-bold"
                v-html="dto.formContent.title"
            />
            <p
                class="small fw-bold mb-0"
                v-html="dto.formContent.text"
            />
        </div>
        <div>
            <AlertMessage
                v-if="showAlertMessage"
                class="ob1-alert"
                :title="dto.formContent.error"
                type="warning"
                with-alert-role
            />
        </div>
        <div class="col-12">
            <TextField
                :model-value="phoneLineValue"
                :label="dto.formContent?.phoneLineTextField || ''"
                :anonymized="true"
                helper-text="10 chiffres commençant par 01 à 09"
                label-id="phone-line-label"
                input-id="phone-line-input"
                type-value="text"
                input-mode-value="tel"
                :is-full-width-input="true"
                :error-message="phoneLineErrorMessage"
                :is-invalid="!!(phoneLineErrorMessage)"
                :is-required="true"
                :max-length="10"
                @change="onPhoneLineChange($event)"
            />
            <TextField
                :model-value="customerCodeValue"
                :label="dto.formContent?.customerCodeTextField || ''"
                :anonymized="true"
                helper-text="10 chiffres"
                label-id="customer-code-label"
                input-id="customer-code-input"
                type-value="text"
                input-mode-value="numeric"
                :is-full-width-input="true"
                :error-message="customerCodeErrorMessage"
                :is-invalid="!!(customerCodeErrorMessage)"
                :is-required="true"
                :max-length="10"
                @change="onCustomerPidChange($event)"
            />
            <Lien
                id="show-info"
                :is-button="true"
                :is-mini="true"
                :is-link-arrow="false"
                :label="dto.formContent.infoLink.label"
                :data-oevent-category="dto.formContent.infoLink.tms.category"
                :data-oevent-action="dto.formContent.infoLink.tms.action"
                :data-oevent-label="dto.formContent.infoLink.tms.label"
                @click="showInfo"
            />
        </div>
    </div>
</template>

<script lang="ts">
import {PropType} from "vue";
import {InternetDiscountPopinDto} from "../../cart/models/InternetDiscountPopinDto";
import TextField from "../ob1/TextField.vue";
import Lien from "../ob1/Lien.vue";
import AlertMessage from "../ob1/AlertMessage.vue";

export default {
    name: "DiscountPopinFormShared",
    components: {
        TextField,
        Lien,
        AlertMessage
    },
    props: {
        activeView: {
            type: String,
            required: true
        },
        dto: {
            type: Object as PropType<InternetDiscountPopinDto>,
            required: true
        },
        phoneLineValue: {
            type: String,
            required: true
        },
        phoneLineErrorMessage: {
            type: String,
            required: true
        },
        customerCodeValue: {
            type: String,
            required: true
        },
        customerCodeErrorMessage: {
            type: String,
            required: true
        },
        showAlertMessage: {
            type: Boolean,
            required: true
        }
    },
    methods: {
        onPhoneLineChange(value: string) {
            const filteredValue = value.replace(/\\D/g, '');
            this.$emit("update:phoneLineValue", filteredValue);
            this.$emit("update:showAlertMessage", false);
            this.$emit("update:phoneLineErrorMessage", "");
            this.$emit("update:customerCodeErrorMessage", "");
        },
        onCustomerPidChange(value: string) {
            const filteredValue = value.replace(/\\D/g, '');
            this.$emit("update:customerCodeValue", filteredValue);
            this.$emit("update:showAlertMessage", false);
            this.$emit("update:phoneLineErrorMessage", "");
            this.$emit("update:customerCodeErrorMessage", "");
        },
        showInfo(event: Event) {
            if (event) {
                event.preventDefault();
            }
            this.$emit("update:activeView", "info");
        }
    }
}
</script>
